import React from 'react';

import FormattedCurrency from '../../../../components/formatted-currency';
import { endingBalance } from '../constants';
import style from '../style.module.less';

/**
 * @param {number} value
 * @param {boolean} isEndingBalanceColumn
 * @returns {number}
 */
const parseValueForEndingBalance = (value, isEndingBalanceColumn) => {
  let parsed = value;
  if (typeof value === 'string') {
    parsed = parseFloat(value);
  }
  return isEndingBalanceColumn ? parsed : Math.abs(parsed);
};

/**
 * @param {object} props
 * @param {import('../transaction-history').CurrencyCell} props.cell
 * @param {{id: string}} props.column
 * @returns {JSX.Element}
 */
export const CurrencyCell = ({ cell, column }) => {
  const isEndingBalanceColumn = column.id === endingBalance;

  return (
    <div className={style.currency}>
      {cell.value ? (
        <FormattedCurrency currencyCode={cell.value.code} value={parseValueForEndingBalance(cell.value.value, isEndingBalanceColumn)} />
      ) : (
        <>&mdash;</>
      )}
    </div>
  );
};
